module.exports = __webpack_public_path__ + "media/images/icons/SVG/036-da8a5b9705d17b7e76d1f86f7f5da18c.svg";